import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
import { mapActions, mapState } from "pinia";
//@ts-ignore
import { deepCopy } from "@utils/ObjectUtils";
//@ts-ignore
import { isArrNullOrEmpty } from "@utils/ArrayUtils";
import { getBasePublicValuation } from "@customTypes/PublicValuation";
import { usePlaceType } from "@wkComposables/usePlaceType";
//@ts-ignore
import { usePlaceName } from "@wkComposables/usePlaceName";
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { PLACE_TYPE } from "@customTypes/PlaceType";
import { getDistrictsByZoneId, getPlace, getZones } from "@services/placesAPI";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { LocationIcon } from "@vueEntry/SvgIcons/LocationIcon";
//@ts-ignore
import { DrawIcon } from "@vueEntry/SvgIcons/DrawIcon";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import { getPlacesAddressAutocomplete } from "@services/geographyAPI";
import { getPlaceFromGAutocomplete } from "@utils/GAutocompleteUtils";
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import RadioButton from "@vueEntry/UIKitComponents/Radio/RadioButton.vue";
import BaseAccordionItem from "@vueEntry/UIKitComponents/Accordion/BaseAccordionItem.vue";
import { defineComponent } from "vue";
import { useSearchBeanStore } from "@store/SearchBeanStore";
export default defineComponent({
  name: "PlaceModal",
  components: {
    RadioButton,
    CheckboxBtn,
    BaseAutocomplete,
    BaseBtModal,
    BaseButton,
    DrawIcon,
    LocationIcon,
    BaseAccordionItem
  },
  props: {
    showPlaceModal: {
      type: Boolean
    },
    listing: {
      type: Boolean
    },
    valuation: {
      type: Boolean
    },
    place: {
      type: Object
    },
    placedIn: {
      type: String,
      default: "real-estate"
    },
    agencyGroup: {
      type: String,
      default: ""
    }
  },
  emits: ["hide-place-modal", "show-map", "emit-place"],
  setup() {
    var {
      currentPlaceName,
      //Refs
      locationLabel,
      zonesLabel,
      //Computed
      //Methods
      setCustomPlaceLabel,
      updateLocationName,
      updateZoneName,
      updateSingleDistrictName,
      updateGenericPlaceName,
      updateCityName
    } = usePlaceName();
    var {
      localityList,
      zoneList,
      searchBeanModal,
      prevSelectedLocality,
      localitySelected,
      prevZoneIDsSelected,
      zoneIDsSelected,
      zoneModifiedByUser,
      districtSelected,
      districtsObj,
      //Computed
      selectedDistrictLength,
      //Methods
      convertEnergyClassFilter,
      convertFloor,
      resetSearchBeanZonesAndLocalities,
      updateSearchModal,
      updateSearchModalAndPlace,
      fixSearchBean,
      initZonesAndLocalities,
      areAllDistrictsSelected,
      isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict,
      getZoneById,
      resetZoneAndLocalities,
      isZoneSelected,
      isLocationSelected,
      isDistrictSelected,
      insertDistrictByZoneId,
      onPlaceLIClick,
      onDistrictClick
    } = usePlaceType();
    var {
      search
    } = useSearch();
    return {
      //Refs
      currentPlaceName,
      //Computed
      locationLabel,
      zonesLabel,
      //Methods
      setCustomPlaceLabel,
      updateLocationName,
      updateZoneName,
      updateSingleDistrictName,
      updateGenericPlaceName,
      updateCityName,
      //usePlaceType
      localityList,
      zoneList,
      searchBeanModal,
      prevSelectedLocality,
      localitySelected,
      prevZoneIDsSelected,
      zoneIDsSelected,
      zoneModifiedByUser,
      districtSelected,
      districtsObj,
      //Computed
      selectedDistrictLength,
      //Methods
      convertEnergyClassFilter,
      convertFloor,
      resetSearchBeanZonesAndLocalities,
      updateSearchModal,
      updateSearchModalAndPlace,
      fixSearchBean,
      initZonesAndLocalities,
      areAllDistrictsSelected,
      isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict,
      getZoneById,
      resetZoneAndLocalities,
      isZoneSelected,
      isLocationSelected,
      isDistrictSelected,
      insertDistrictByZoneId,
      onPlaceLIClick,
      onDistrictClick,
      //useSearch
      search
    };
  },
  data() {
    return {
      valuationAddress: undefined,
      autocompleteValue: undefined,
      disableCb: true,
      placeTest: null,
      mapPlace: null,
      prevSearchBeanModal: getDefaultSearchBean(),
      showMapModal: false,
      aroundMe: false,
      tempListUpdated: false,
      tempZoneList: [],
      tempLocalityList: [],
      showZoneModal: false,
      previousPlaceName: "",
      cityModal: false,
      tempPlace: null,
      publicValuation: getBasePublicValuation(),
      openPlaceModal: false,
      pmCustomEvent: null,
      cautocompleteELSelected: false,
      modalBodyHeight: 0,
      agencyFilter: {
        name: "",
        franchiseId: null
      }
    };
  },
  computed: Object.assign({
    currentName() {
      return this.currentPlaceName;
    },
    localitiesLabel() {
      return window["_labels"].localities;
    },
    cdn() {
      return window["_cdn"];
    },
    labels() {
      return window["_labels"];
    },
    hasValuationAddress() {
      var _a;
      return !!((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address);
    },
    address() {
      return this.publicValuation.realEstateValuation.address;
    },
    agencyListingTypologyURL() {
      return this.labels.macroTypology_url_5;
    }
  }, mapState(useSearchBeanStore, ["searchBean"])),
  watch: {
    showPlaceModal(cur) {
      this.openPlaceModal = cur;
    },
    cautocompleteELSelected(cur) {
      if (cur) {
        this.openCityModal();
      }
    },
    currentPlaceName(cur, prev) {
      this.autocompleteValue = {
        label: cur
      };
    }
  },
  created() {
    this.openPlaceModal = this.showPlaceModal;
    if (this.valuation) {
      this.openCityModal();
      return;
    }
    /*        if (this.place?.zoneID && isArrNullOrEmpty(this.zoneIDsSelected))
        this.zoneIDsSelected.push(this.place?.zoneID)*/
    this.updateSearchModal(this.searchBean);
    this.convertEnergyClassFilter();
    this.convertFloor();
    if (this.place) this.placeTest = deepCopy(this.place);
  },
  mounted() {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.valuation) this.modalBodyHeight = (_a = document.querySelector("#place-modal .modal-body")) === null || _a === void 0 ? void 0 : _a.offsetHeight;
      var {
        zoneIdList,
        cityId
      } = this.searchBeanModal;
      // if (this.placeTest?.zoneID && !this.placeTest.districtID)
      if ((this.searchBeanModal.zoneId || ((_b = this.searchBeanModal.zoneIdList) === null || _b === void 0 ? void 0 : _b.length) === 1) && (!this.searchBeanModal.districtId || !((_c = this.searchBeanModal.districtIdList) === null || _c === void 0 ? void 0 : _c.length))) {
        this.zoneIDsSelected = this.searchBeanModal.zoneId ? [this.searchBeanModal.zoneId] : this.searchBeanModal.zoneIdList;
        if (this.searchBeanModal.zoneId) this.searchBeanModal.zoneIdList = [this.searchBeanModal.zoneId];
      } else if (!isArrNullOrEmpty(zoneIdList) && !this.valuation && ((_d = this.placeTest) === null || _d === void 0 ? void 0 : _d.placeType) !== "D") {
        this.zoneIDsSelected = zoneIdList;
      } else if (((_e = this.placeTest) === null || _e === void 0 ? void 0 : _e.placeType) === PLACE_TYPE.DISTRICT) {
        this.searchBeanModal.zoneId = null;
        this.searchBeanModal.zoneIdList = [];
        this.zoneIDsSelected = [];
      }
      //Just one zone
      if (cityId) yield this.initZonesAndLocalities(getZones(cityId));
      if (((_f = this.placeTest) === null || _f === void 0 ? void 0 : _f.placeType) === PLACE_TYPE.LOCALITY && this.searchBeanModal.localityIdList)
        //@ts-ignore
        this.localitySelected = this.localityList.find(l => l.localityID === this.searchBeanModal.localityIdList[0]);
      this.updatePlaceName();
      if (this.valuation) this.openCityModal();
    });
  },
  methods: Object.assign({
    manageCity(city, updatePlaceCb, action) {
      var initZonesAndLocalities = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      this.updateSearchModalAndPlace(city, () => {
        this.placeTest = Object.assign({}, city);
        this.tempPlace = Object.assign({}, this.placeTest);
      });
      if (initZonesAndLocalities) {
        this.initZonesAndLocalities(getZones(city.cityID), () => {
          action && action();
          this.openZoneModal();
        }, () => this.updateSearchModalAndPlace(city, updatePlaceCb));
      } else action && action();
    },
    initSingleDistrict(zoneId, districtId) {
      return __awaiter(this, void 0, void 0, function* () {
        var districts = yield getDistrictsByZoneId(zoneId);
        var singleDistrict = districts.find(d => d.districtID === districtId);
        this.$set(this.districtsObj, singleDistrict === null || singleDistrict === void 0 ? void 0 : singleDistrict.zoneID, [singleDistrict]);
        //Adding the district to the district object
        this.insertDistrictByZoneId(zoneId, districtId);
      });
    },
    onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!query) return;
        var res = yield getPlacesAddressAutocomplete(query, 10);
        return res.map(r => ({
          label: r.description,
          id: r.place_id
        }));
      });
    },
    optionSelectedCb(selectedEl) {
      return __awaiter(this, void 0, void 0, function* () {
        var {
          place,
          address
        } = yield getPlaceFromGAutocomplete("".concat(selectedEl.id), selectedEl.label);
        this.tempPlace = place;
        this.valuationAddress = {
          label: address
        };
        this.confirmPlace();
      });
    },
    handleClick() {
      this.$refs.placeAutocomplete.select();
      this.disableCb = false;
      if (this.zoneList.length > 0 || this.localitySelected) this.showZoneModal = true;
    },
    removeTopLocalitySelected() {
      this.cautocompleteELSelected = false;
    },
    handleChange(curVal) {
      if (!curVal) {
        this.clearCautocomplete();
      } else this.currentPlaceName = curVal;
    },
    closeModal() {
      this.pmCustomEvent = {
        type: "hide-place-modal"
      };
      this.openPlaceModal = false;
    },
    clearCautocomplete() {
      this.setCustomPlaceLabel("");
      this.zoneList = [];
      this.localityList = [];
      this.placeTest = null;
      this.cityModal = false;
      this.showZoneModal = false;
    },
    //Whenever we select a city from the result of the autocomplete this function will be called
    managePlace(obj) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var initZonesAndLocalities = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!obj) return;
      this.disableCb = true;
      this.resetSearchBeanZonesAndLocalities();
      var updatePlaceCb = () => {
        this.placeTest = Object.assign({}, obj);
        this.confirmPlace();
      };
      if (obj.placeType == PLACE_TYPE.CITY) {
        this.manageCity(obj, updatePlaceCb, action, initZonesAndLocalities);
      } else if (obj.placeType == PLACE_TYPE.DISTRICT) {
        this.initSingleDistrict(obj.zoneID, obj.districtID).then(() => {
          this.updateSearchModalAndPlace(obj, updatePlaceCb);
        });
      } else
        //e.g. if the selected option is a province...
        this.updateSearchModalAndPlace(obj, updatePlaceCb);
      this.updatePlaceName();
    },
    updatePlaceName() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      /* LOCALITY */
      if (this.localitySelected || ((_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.localityID) && !this.zoneIDsSelected.length) {
        this.updateLocationName((_b = this.localitySelected) !== null && _b !== void 0 ? _b : this.placeTest);
        return;
      }
      /* DRAWN AREA MAP */
      // eslint-disable-next-line max-len
      if (this.listing && !!this.searchBeanModal.polygonFromMap && this.searchBeanModal.placeType != "I" || !this.listing && !!this.searchBean.polygonFromMap && this.searchBean.placeType != "I") {
        this.currentPlaceName = this.labels.mapAreaDrawn;
      }
      /* VACATION PLACE LIKE CINQUE TERRE */else if (!!this.searchBean.polygonFromMap && this.searchBean.placeType == "I") {
        this.currentPlaceName = (_c = this.searchBean) === null || _c === void 0 ? void 0 : _c.cityDisplayName;
      } else if (this.searchBeanModal.placeType == PLACE_TYPE.AREA) {
        this.updateGenericPlaceName(this.placeTest);
      } else {
        //Zones and district greater than one
        if (this.zoneIDsSelected.length >= 0 || ((_d = this.searchBeanModal.districtIdList) === null || _d === void 0 ? void 0 : _d.length) >= 0) {
          if ([PLACE_TYPE.PROVINCE, PLACE_TYPE.AREA_OF_INTEREST, PLACE_TYPE.REGION, PLACE_TYPE.LOCALITY].includes(((_e = this.placeTest) === null || _e === void 0 ? void 0 : _e.placeType) || "") && !this.zoneIDsSelected.length //This check is done to exclude the following scenario: Olbia -> locality, close and open modal, select zones
          ) this.updateGenericPlaceName(this.placeTest);else if (!((_f = this.searchBeanModal.districtIdList) === null || _f === void 0 ? void 0 : _f.length) && !this.zoneIDsSelected.length) this.updateCityName(this.placeTest);else if (!this.zoneIDsSelected.length && ((_g = this.searchBeanModal.districtIdList) === null || _g === void 0 ? void 0 : _g.length) === 1 /*|| this.placeTest?.placeType === PLACE_TYPE.DISTRICT*/) this.updateSingleDistrictName(this.getSingleSelectedDistrict());else if (this.zoneIDsSelected.length === 1 && !((_h = this.searchBeanModal.districtIdList) === null || _h === void 0 ? void 0 : _h.length)) this.updateZoneName(this.getZoneById(this.zoneIDsSelected[0]), 1);else this.updateZoneName(this.placeTest, this.zoneIDsSelected.length + ((_j = this.searchBeanModal.districtIdList) === null || _j === void 0 ? void 0 : _j.length));
        }
      }
    },
    close() {
      if (this.listing) {
        this.placedIn === "agency" ? this.search(true, this.agencyListingTypologyURL, false, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null) : this.search(this.searchBeanModal);
      } else this.emitPlace();
    },
    openCityModal() {
      this.cityModal = true;
    },
    getPlaceFn(query) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!query) return;
        this.autocompleteValue = {
          label: query
        };
        this.resetZoneAndLocalities();
        var res = yield getPlace(query, "C,P,Z,L,I,R,A,D");
        //@ts-ignore
        return res.map((place, index) => ({
          id: index,
          label: place.displayName,
          payload: place
        }));
      });
    },
    onWholeMunicipalityClick() {
      var resetLocalityId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var updateCityName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.zoneIDsSelected = [];
      this.localitySelected = undefined;
      //In order to update correctly the locality id, which will be null in case we check the option "whole municipality", we set the locality id to a valid falsy value!
      if (this.placeTest && resetLocalityId) this.placeTest.localityID = 0;
      //If there is no info about the zones in and the localities in the searchBean, then we will try to search by the city!
      this.searchBeanModal.zoneId = null;
      this.searchBeanModal.zoneIdList = [];
      this.searchBeanModal.zoneURL = null;
      this.searchBeanModal.localityIdList = [];
      this.searchBeanModal.districtId = null;
      this.searchBeanModal.districtIdList = [];
      this.districtSelected = {};
      //When we select the whole municipality, we will update the current field with the name of the city!
      updateCityName && this.updateCityName(this.placeTest);
      //Updating the place modal with a valid display name
      this.placeTest = Object.assign(Object.assign({}, this.placeTest), {
        displayName: this.currentPlaceName
      });
    },
    confirmPlace() {
      var _a, _b;
      if (this.valuation) {
        this.publicValuation.realEstateValuation.address = ((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address) || "";
        this.placeTest = Object.assign({}, this.tempPlace);
        this.tempPlace = null;
        this.emitPlace();
      } else {
        /* Handling whole municipality scenario */
        if (!this.isZoneOrLocalitySelected() && !(Object.keys(this.districtSelected).length > 0) && ((_b = this.placeTest) === null || _b === void 0 ? void 0 : _b.placeType) === PLACE_TYPE.CITY) {
          this.onWholeMunicipalityClick(false, false);
        }
        this.fixSearchBean(() => {
          var _a;
          this.placeTest = this.zoneList.find(plc => plc.zoneID == this.searchBeanModal.zoneId) || this.placeTest;
          return (_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, () => {
          var _a;
          this.placeTest = this.localitySelected ? Object.assign({}, this.localitySelected) : this.placeTest;
          return (_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, () => {
          var _a;
          return (_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        });
        this.updatePlaceName();
        delete this.searchBeanModal.polygonFromMap;
        delete this.searchBeanModal.polygonForDB;
        this.updateSearchBean({
          polygonFromMap: this.searchBeanModal.polygonFromMap,
          polygonForDB: this.searchBeanModal.polygonForDB,
          placeId: this.searchBeanModal.placeId,
          zoneIdList: this.searchBeanModal.zoneIdList,
          localityIdList: this.searchBeanModal.localityIdList,
          zoneId: this.searchBeanModal.zoneId,
          cityId: this.searchBeanModal.cityId,
          cityDisplayName: this.searchBeanModal.cityDisplayName,
          cityURL: this.searchBeanModal.cityURL,
          zoneURL: this.searchBeanModal.zoneURL,
          districtURL: this.searchBeanModal.districtURL,
          districtId: this.searchBeanModal.districtId,
          districtIdList: this.searchBeanModal.districtIdList
        });
        this.prevSearchBeanModal = deepCopy(this.searchBeanModal);
        this.prevZoneIDsSelected = [...this.zoneIDsSelected];
        this.prevSelectedLocality = this.localitySelected ? Object.assign({}, this.localitySelected) : undefined;
        //Since the user has accepted its search, we can update the temp buffers!
        this.tempLocalityList = [...this.localityList];
        this.tempZoneList = [...this.zoneList];
        this.previousPlaceName = this.currentPlaceName;
        this.tempPlace = this.placeTest ? Object.assign({}, this.placeTest) : null;
        if (this.listing) {
          this.placedIn === "agency" ? this.search(true, this.agencyListingTypologyURL, false, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null) : this.search(this.listing);
        } else this.emitPlace();
      }
    },
    browserSupportGeolocation() {
      return !!window.navigator.geolocation;
    },
    openMapDraw() {
      this.showMap();
    },
    openMapAroundMe() {
      this.aroundMe = true;
      this.openMapDraw();
    },
    hideMapModal() {
      this.showMapModal = false;
    },
    openZoneModal() {
      //Now that we have extracted from the zoneList the localities, we have to check the length of both the lists!
      if (this.valuation) return;
      this.cityModal = true;
      this.showZoneModal = !!(this.zoneList.length + this.localityList.length);
    },
    closeZoneModal() {
      this.showZoneModal = false;
    },
    hidePlaceModal() {
      //Whenever we click the "go back" button, we will retrieve the previous search results!
      this.zoneList = [...this.tempZoneList];
      this.localityList = [...this.tempLocalityList];
      if (!this.pmCustomEvent) this.$emit("hide-place-modal");else this.$emit(this.pmCustomEvent.type, this.pmCustomEvent.payload);
    },
    showMap() {
      this.$emit("show-map", {
        aroundMe: this.aroundMe,
        searchBean: this.searchBeanModal
      });
    },
    emitPlace() {
      var _a, _b, _c, _d;
      this.updateSearchBean({
        zoneIdList: this.searchBeanModal.zoneIdList
      });
      if (((_a = this.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.length) === 1 && !((_b = this.searchBeanModal.zoneIdList) === null || _b === void 0 ? void 0 : _b.length)) {
        if (this.placeTest) this.placeTest.districtName = (_d = (_c = this.getSingleSelectedDistrict()) === null || _c === void 0 ? void 0 : _c.districtName) !== null && _d !== void 0 ? _d : "";
      }
      this.pmCustomEvent = {
        type: "emit-place",
        payload: {
          place: this.placeTest,
          aroundMe: false,
          radius: 0,
          searchBean: this.searchBean,
          polygon: "",
          polygonFromMap: "",
          polygonForDB: ""
        }
      };
      this.openPlaceModal = false;
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"]))
});